var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDropArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.055 7.356l3.813 3.824c.39.392 1.031.386 1.422-.006.39-.39.395-1.027.006-1.418L8.763 5.21a1 1 0 00-1.417 0L2.704 9.866c-.39.39-.383 1.028.006 1.418.39.392 1.031.398 1.422.006l3.923-3.934z",
  fill: "#000"
})));
export { SvgDropArrow as ReactComponent };